import { Color } from "@repo/app-types/constants/colors";
import { getTalkRatioColor } from "@repo/app-types/constants/talkRatio";
import type { Size } from "@repo/ui/helpers/helpers";
import { getPillColor, Pill } from "@repo/ui/Pills/pill";
import { PillSkeleton } from "@repo/ui/Pills/pillSkeleton";
import type { FC } from "react";

export interface GradingTalkRatioPillProps {
  size: Size;
  /**
   * The 0-1 talk ratio. `undefined` means the number is absent (no data in
   * the period) and renders as a muted `--`; `null` means the metric is
   * genuinely inapplicable and renders as an "N/A" pill.
   */
  talkRatio: number | null | undefined;
  isLoading?: boolean;
  onClick?: () => void;
}

export const GradingTalkRatioPill: FC<GradingTalkRatioPillProps> = (props) => {
  const { talkRatio } = props;

  if (talkRatio == null && props.isLoading) {
    return <PillSkeleton size={props.size} />;
  }

  if (talkRatio === null) {
    return (
      <Pill
        color={Color.Gray}
        size={props.size}
        label="N/A"
        onClick={props.onClick}
      />
    );
  }

  if (talkRatio === undefined) {
    return <span className="text-muted-foreground">--</span>;
  }

  const label = `${(talkRatio * 100).toFixed(0)}%`;

  return (
    <Pill
      color={computeColor(talkRatio)}
      size={props.size}
      label={label}
      onClick={props.onClick}
    />
  );
};

function computeColor(talkRatio: number) {
  const talkRatioColor = getTalkRatioColor(talkRatio);
  return getPillColor(talkRatioColor);
}
